import { queryOptions } from '@tanstack/react-query';

import { apiGammaTeamFetch, apiUserFetch } from '@/api';
import { cleanParams } from '@/utils/cleanParams';

import {
  GAMMA_TEAM_QUERY_KEYS,
  GetActivityParams,
  GetGammaTeamDashboardParams,
  GetGammaTeamDashboardRes,
  MemberActivityResponse,
  MyGammaTeamInvitation,
  TeamActivityResponse,
} from './types';

export const _getGammaTeamDashboard = (params: GetGammaTeamDashboardParams) =>
  queryOptions({
    queryKey: [GAMMA_TEAM_QUERY_KEYS.dashboard, params],
    queryFn: () =>
      apiGammaTeamFetch<GetGammaTeamDashboardRes>('/dashboard', {
        params: {
          page: params.page,
          limit: params.limit,
          ...(params.search && { search: params.search }),
          ...(params.role && { role: params.role }),
          ...(params.status && { status: params.status }),
        },
      }),
  });

export const _getMyGammaTeamInvitations = () =>
  queryOptions({
    queryKey: [GAMMA_TEAM_QUERY_KEYS.myInvitations],
    queryFn: () => apiUserFetch<MyGammaTeamInvitation[]>('/invitations/my'),
    refetchOnMount: true,
  });

export const _getTeamActivity = (params: GetActivityParams) =>
  queryOptions({
    queryKey: [GAMMA_TEAM_QUERY_KEYS.activity, params],
    queryFn: () =>
      apiGammaTeamFetch<TeamActivityResponse>('/activity', { params: cleanParams(params) }),
  });

export const _getMemberActivity = (userId: string, params: GetActivityParams) =>
  queryOptions({
    queryKey: [GAMMA_TEAM_QUERY_KEYS.memberActivity, userId, params],
    queryFn: () =>
      apiGammaTeamFetch<MemberActivityResponse>(`/activity/members/${userId}`, {
        params: cleanParams(params),
      }),
  });
